// extracted by mini-css-extract-plugin
export default {"melodyVideo":"iL-z","isFullWidth":"jL-z","landingPageVideo":"kL-z","play":"lL-z","iframeVideo":"mL-z","playHidden":"nL-z","fullwidth":"oL-z"};